module.exports = __webpack_public_path__ + "img/cfil-wallet.b905910d.png";